export default __webpack_public_path__ + "static/media/banner3.6d747761.png";